import React from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'

import { switchAppointmentOrBudget } from './../services/actions'
import { fetchMainServices, renderSearchMainServiceKm } from './../../../catalogue'
import { switchCheckoutContent } from './../checkoutContent/actions'
import { setBeforeBudget } from "./actions"
import { configuration } from '../../../configuration'


class AppointmentOrBudget extends React.Component {

  static propTypes = {

  }

  constructor(props) {
    super(props);

  }

  componentWillMount() {
    this.props.renderSearchMainServiceKm(false)
  }

  back(car) {
    this.props.fetchMainServices(car)
    this.props.switchAppointmentOrBudget(false)
  }

  goToAppointment() {
    this.props.setBeforeBudget(true);
    this.props.switchCheckoutContent('appointment');
  }
  goToPersonalData() {
    this.props.setBeforeBudget(false);
    this.props.switchCheckoutContent('personalData');
  }

  render() {
    const copyBudgetMessage1 = 'No podemos mostrarte el precio del servicio solicitado.'
    //const copyBudgetMessage2 = configuration().copyBudgetMessage2 ? configuration().copyBudgetMessage2 : 'Finaliza el proceso y te lo enviaremos en menos de 8 h.'
    const copyBudgetMessage3 = '¿Quieres continuar con tu cita o conocer el presupuesto?'

    return (
      <div>
        <br />
        <br />
        <div style={{ textAlign: 'center' }}>
          <p>{copyBudgetMessage1}</p>
          <p>{copyBudgetMessage3}</p>
        </div>

        <Row>
          <Col sm={12} md={4}>
            <button className=" responsivebutton jump button-no-grey" style={{ color: configuration().btnColor, backgroundColor: configuration().clientColor, borderColor: configuration().clientColor }} onClick={() => this.goToAppointment()}>
              <span className="labelFlip1 text-button-yes-no">Cita</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>Cita</span>
            </button>
          </Col>
          <Col sm={12} md={4} className="offset-md-4">
            <button className=" responsivebutton jump button-secondary button-no-grey" style={{ float: 'right' }} onClick={() => this.goToPersonalData()}>
              <span className="labelFlip1 text-button-yes-no">Presupuesto</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>Presupuesto</span>
            </button>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={4}>
            <button className=" responsivebutton jump pull-left button-secondary router-buttons" onClick={() => this.back(this.props.car)}> {configuration().arrowInButon ? <i className="fa fa-angle-left" aria-hidden="true"></i> : ''}
              <span className="labelFlip1">ATRÁS</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>ATRÁS</span>
            </button>
          </Col>
        </Row>
        <br />
      </div>

    );
  }
}

const mapStateToProps = state => ({
});

const bindActions = dispatch => ({
  switchAppointmentOrBudget: (renderAppointmentOrBudget) => dispatch(switchAppointmentOrBudget(renderAppointmentOrBudget)),
  fetchMainServices: (car) => dispatch(fetchMainServices(car)),
  renderSearchMainServiceKm: (mainServiceKm) => dispatch(renderSearchMainServiceKm(mainServiceKm)),
  switchCheckoutContent: content => dispatch(switchCheckoutContent(content)),
  setBeforeBudget: beforeBudget => dispatch(setBeforeBudget(beforeBudget)),

});

export default connect(mapStateToProps, bindActions)(AppointmentOrBudget);



// WEBPACK FOOTER //
// ./src/workflow/checkout/appointment/appointmentOrBudget.component.js